import React, { PropTypes } from 'react'
import { translate } from 'react-i18next'
import styled from 'styled-components'
import Modal from '../../../components/Modal'
import Button from '../../../components/Button'
import Input from '../../../components/Input'
import { Colors, Metrics, Fonts } from '../../../Themes'

const CustomInput = styled(Input)`
  margin-bottom: ${Metrics.margins.base};

  .inputTitle {
    color: ${Colors.primary};
  }
`

const CustomButton = styled(Button)`
  margin-top: ${Metrics.margins.large};
`

const Error = styled.div`
  margin-top: ${Metrics.margins.tiny};
  margin-bottom: ${Metrics.margins.small};
  ${Fonts.style.Input};
  color: ${Colors.red};
`

const Password = props => {
  const {
    profile,
    t,
    handleChange,
    handleConfirm,
    confirmPassword,
    next,
    router
  } = props
  return (
    <Modal
      visible
      closeAction={() => router.push('/landing')}
      header={<div className={'header'}>{t('Password')}</div>}
      backAction={props.router.goBack}>
      <CustomInput
        type={'password'}
        placeholder={t('Insert your password')}
        title={t('Password')}
        key='pass'
        value={profile.password}
        handleChange={event => handleChange('password', event)}
      />
      <CustomInput
        type={'password'}
        key='confirmPass'
        value={confirmPassword}
        title={t('Confirm Password')}
        handleChange={handleConfirm}
        placeholder={t('Confirm your password')}
      />
      {profile.password.length > 0 && profile.password !== confirmPassword ? (
        <Error>{t("Passwords don't match")}</Error>
      ) : (
        ''
      )}
      <CustomButton
        label={t('Next')}
        onClick={() => next('/landing/signup/terms')}
        disabled={
          !(profile.password.length > 0 && profile.password === confirmPassword)
        }
      />
    </Modal>
  )
}

Password.propTypes = {
  confirmPassword: PropTypes.string,
  handleConfirm: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  next: PropTypes.func.isRequired,
  router: PropTypes.object,
  t: PropTypes.func
}

export default translate([ 'common', 'landing', 'forms' ], { wait: true })(
  Password
)



// WEBPACK FOOTER //
// ./src/pages/Landing/Onboarding/Password.js